module.exports = __webpack_public_path__ + "media/bootstrap-icons/music-player-fill-9fdcf6cd.svg";